import { Slider3 } from '../../../core'
import { FormLabel } from '../../../form'
import { styled } from '../../../styles'
import { BaseThemeType } from '../../../theme'
import { CheckoutFinancingPricingParams } from '../types'

type PropTypes = {
  pricingParams: CheckoutFinancingPricingParams
  updatePricingParams: (newParams: CheckoutFinancingPricingParams) => void
}

const MainWrapper = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  backgroundColor: '#FAFBFC',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '10px',
  flex: 1,
}))

const FinanceMarketplaceFinancingCard = (props: PropTypes) => {
  return (
    <MainWrapper>
      <div>
        <Slider3 header="Initial Payment" showNumberInput showNumericals min={0} max={20000} />
      </div>
      <div>
        <FormLabel>Loan Term</FormLabel>
        <Slider3 min={0} max={100} />
      </div>
    </MainWrapper>
  )
}
export default FinanceMarketplaceFinancingCard
